import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../../configure";
import {P,SectionSmallHeading,SectionSubHeading,SectionTitleHeading,SectionWrapper} from "../../../styles";

const Contact = styled.a`
  text-align: left;
`;

const Index = () => {
  const [ getProNameA, setProNameA ] = useState('');
  const [ getProPhoneA, setProPhoneA ] = useState('');
  const [ getProEmailA, setProEmailA ] = useState('');
  const [ getProNameB, setProNameB ] = useState('');
  const [ getProPhoneB, setProPhoneB ] = useState('');
  const [ getProEmailB, setProEmailB ] = useState('');
  const [ getProNameC, setProNameC ] = useState('');
  const [ getProPhoneC, setProPhoneC ] = useState('');
  const [ getProEmailC, setProEmailC ] = useState('');
  
  const [ getInqNameA, setInqNameA ] = useState('');
  const [ getInqPhoneA, setInqPhoneA ] = useState('');
  const [ getInqEmailA, setInqEmailA ] = useState('');
  const [ getInqNameB, setInqNameB ] = useState('');
  const [ getInqPhoneB, setInqPhoneB ] = useState('');
  const [ getInqEmailB, setInqEmailB ] = useState('');
  const [ getInqNameC, setInqNameC ] = useState('');
  const [ getInqPhoneC, setInqPhoneC ] = useState('');
  const [ getInqEmailC, setInqEmailC ] = useState('');
  
  useEffect(()=>{
      fetch(BASEURL+'contacts', {
        method: 'GET',
      }).then(response => response.json())
      .then( jsonData => {
        setProNameA(jsonData[0]?.prodname1)
        setProPhoneA(jsonData[0]?.prodphone1)
        setProEmailA(jsonData[0]?.prodemail1)
        setProNameB(jsonData[0]?.prodname2)
        setProPhoneB(jsonData[0]?.prodphone2)
        setProEmailB(jsonData[0]?.prodemail2)
        setProNameC(jsonData[0]?.prodname3)
        setProPhoneC(jsonData[0]?.prodphone3)
        setProEmailC(jsonData[0]?.prodemail3)
        
        setInqNameA(jsonData[1]?.prodname1)
        setInqPhoneA(jsonData[1]?.prodphone1)
        setInqEmailA(jsonData[1]?.prodemail1)
        setInqNameB(jsonData[1]?.prodname2)
        setInqPhoneB(jsonData[1]?.prodphone2)
        setInqEmailB(jsonData[1]?.prodemail2)
        setInqNameC(jsonData[1]?.prodname3)
        setInqPhoneC(jsonData[1]?.prodphone3)
        setInqEmailC(jsonData[1]?.prodemail3)
      }) 
  },[getProNameA, getProPhoneA, getProEmailA])
  return (
    <div>
      <SectionWrapper p="0rem 0" m="-1px 0" id="contactus">
        <Container maxWidth="xl">
          <SectionSubHeading align="left" fs599="50px" p="50px 0" color="#0A0A0A" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-duration="600" data-aos-delay="600" data-aos-offset="0" >
            Contact Us
          </SectionSubHeading>
          <Grid container>
            <Grid xs={12} md={8}>
              <SectionTitleHeading fs="30px" color="#0A0A0A" data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
                Production
              </SectionTitleHeading>
              <P tlj="unset" m="0" padding="10px 0 0px 0" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-easing="ease-in" data-aos-offset="0" >
                For all inquiries regarding production and <br />
                projects,
              </P>
              <P m="0" padding="0px 0 10px 0" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-easing="ease-in" data-aos-offset="0" >
                please contact:
              </P>
              { getProNameA ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getProNameA}
                </SectionSmallHeading>
                : null
              }
              { getProPhoneA ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getProPhoneA}`} >
                  {getProPhoneA}
                </Contact>
                : null
              }
              { getProEmailA ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getProEmailA}`} >
                  {getProEmailA}
                </Contact>
                : null
              }
              { getProNameB ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getProNameB}
                </SectionSmallHeading>
                : null
              }
              { getProPhoneB ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getProPhoneB}`} >
                  {getProPhoneB}
                </Contact>
                : null
              }
              { getProEmailB ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getProEmailB}`} >
                  {getProEmailB}
                </Contact>
                : null
              }
              { getProNameC ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getProNameC}
                </SectionSmallHeading>
                : null
              }
              { getProPhoneC ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getProPhoneC}`} >
                  {getProPhoneC}
                </Contact>
                : null
              }
              { getProEmailC ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getProEmailC}`} >
                  {getProEmailC}
                </Contact>
                : null
              }
            </Grid>
            <Grid xs={12} md={4}>
              <SectionTitleHeading p599="60px 0 0 0" fs="30px" color="#0A0A0A" data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
                Media Inquiries & Partnership
              </SectionTitleHeading>
              <P  tlj="unset" m="0" padding="10px 0 0 0" data-aos="fade-up" data-aos-easing="ease-in" data-aos-duration="500" data-aos-delay="500" data-aos-offset="0" >
                For all inquiries regarding marketing and public relations,
              </P>
              <P m="0" padding="0px 0 10px 0" data-aos="fade-up" data-aos-easing="ease-in" data-aos-duration="500" data-aos-delay="500" data-aos-offset="0" >
                please contact:
              </P>
              
              { getInqNameA ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getInqNameA}
                </SectionSmallHeading>
                : null
              }
              { getInqPhoneA ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getInqPhoneA}`} >
                  {getInqPhoneA}
                </Contact>
                : null
              }
              { getInqEmailA ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getInqEmailA}`} >
                  {getInqEmailA}
                </Contact>
                : null
              }
              { getInqNameB ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getInqNameB}
                </SectionSmallHeading>
                : null
              }
              { getInqPhoneB ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getInqPhoneB}`} >
                  {getInqPhoneB}
                </Contact>
                : null
              }
              { getInqEmailB ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getInqEmailB}`} >
                  {getInqEmailB}
                </Contact>
                : null
              }
              { getInqNameC ?
                <SectionSmallHeading align="left" color="#0A0A0A" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" >
                  {getInqNameC}
                </SectionSmallHeading>
                : null
              }
              { getInqPhoneC ?
                <Contact data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="600" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`tel:${getInqPhoneC}`} >
                  {getInqPhoneC}
                </Contact>
                : null
              }
              { getInqEmailC ?
                <Contact data-aos="fade-up" data-aos-duration="700" data-aos-easing="ease-in" data-aos-delay="700" data-aos-offset="0" style={{ color: "#000", textDecoration: "none", display: 'block' }} href={`mailto:${getInqEmailC}`} >
                  {getInqEmailC}
                </Contact>
                : null
              }
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
